interface IParams extends Intl.NumberFormatOptions {
  value?: number | null | '';
  locale?: string;
  minimumFractionDigits?: number;
  invalidValue?: string;
  decimal?: boolean;
}

export const formatNumber = ({ value, locale, invalidValue = 'n/a', ...options }: IParams) => {
  if (value === null || value === undefined || value === '') {
    return invalidValue;
  }

  if (options.decimal) {
    options = {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      ...options,
    };
  }

  if (options.style === 'percent') {
    options = {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      ...options,
    };
  }

  try {
    return new Intl.NumberFormat(locale, options).format(value);
  } catch {
    return invalidValue;
  }
};
